package nl.astraeus.wiki.messages

class CreatePageMessage() : Message(
  MessageType.CREATE_PAGE,
  MessageHeader.WIKI_ID,
) {

  constructor(msg: String) : this() {
    this.message = msg
  }

  constructor(wikiId: Long) : this() {
    setHeader(MessageHeader.WIKI_ID, wikiId.toString())
  }
}
